
export const COPO_UNDEFINED = undefined;
export const COPO_TRUE = true;
export const COPO_FALSE = false;
export const COPO_EMPTY = "";
